import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApiService, RequirementLevel, USER_ROLES } from 'src/app/core/services/api.service';
import { UserProxy } from 'src/app/core/store/user/user.proxy';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'skill-range-selector',
  templateUrl: 'skill-range-selector.component.html',
  styleUrls: ['skill-range-selector.component.scss']
})
export class SkillRangeSelectorComponent {

  @Input() control: FormGroup;
  @Input() tradeOffMax = null;
  @Input() tradeOffSelected = null;
  @Input() searchTerm = '';
  @Input() selectedBranch = null;
  @Input() mustHave = false;
  @Input() noShadow = false;
   @Input() jobTitle = '';
  @Input() seniority: 'junior' | 'middle' | 'senior'; // accepts seniority from parent
  @Output() skillsToStore = new EventEmitter<any>();
  USER_ROLES = USER_ROLES;
  role$ = this.userProxy.currentRole$;
  onboardingRole$ = this.userProxy.onboardingRole$;
  showToolTip = false;
  assessmentAvailable = false;
  assessmentChecked = false;
  assessmentId = null;
  constructor(
    private userProxy: UserProxy,
    private apiservice: ApiService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    const skillName = this.control?.get('name')?.value;
    this.checkAssessment(skillName);
  }

  checkAssessment(skillName: string) {
    if (!skillName) return;

    this.assessmentChecked = false;
    const keywords = [skillName];
    const searchDto = {
                jobTitle: "",
                branches: [],
                skill: [skillName],
                jobTitles: []
              };
    this.apiservice.CheckAssessment(searchDto).subscribe({
      next: (res) => {
        this.assessmentAvailable = false;
        this.assessmentId = null;

        if (res.data) {
          res.data.forEach(element => {
            if (
              Array.isArray(element.levels) &&
              element.levels.includes(this.seniority)
            ) {
              if(element.skill.toLowerCase() === skillName.toLowerCase())
              {
                  this.assessmentId = element.id;
                  this.assessmentAvailable = true;
              }
              
            }
          });
        }
        this.assessmentChecked = true;
      },
      error: (err) => {
        this.assessmentAvailable = false;
        this.assessmentChecked = true;
      }
    });
  }

  setYears(val: any) {
    const control = this.control.get('years')
    control.setValue(control.value + val);
    this.skillsToStore.emit();
  }

  getRequirementLevelDescription(level: number): string {
    const keys: Record<number, string> = {
      0: 'SkillRequirementLevel.LowPriorityDescription',
      1: 'SkillRequirementLevel.NiceToHaveDescription',
      2: 'SkillRequirementLevel.CouldHaveDescription',
      3: 'SkillRequirementLevel.ShouldHaveDescription',
      4: 'SkillRequirementLevel.MustHaveDescription',
    };
    return this.translateService.instant(keys[level] || '');
  }

  getRequirementLevelLabel(value: number): string {
    const keys: Record<number, string> = {
      0: 'SkillRequirementLevel.LowPriority',
      1: 'SkillRequirementLevel.NiceToHave',
      2: 'SkillRequirementLevel.CouldHave',
      3: 'SkillRequirementLevel.ShouldHave',
      4: 'SkillRequirementLevel.MustHave',
    };
    return this.translateService.instant(keys[value] !== undefined ? keys[value] : 'SkillRequirementLevel.PleaseSelect');
  }

  requirmentLevelRangeChanged() {
    const value = this.control.get('requirementLevel').value;
    if (value) {
      this.control.get('requirementLevel').setValue(value, { emitEvent: false });
      // Automatically set isRequired to false if level is not "must have" (4)
      if (value !== 4 && this.control.get('isRequired').value === true) {
        this.control.get('isRequired').setValue(false, { emitEvent: false });
      }
    }
    this.skillsToStore.emit();
  }

  isRequiredChanged(value: boolean) {
    this.control.get('isRequired').setValue(value, { emitEvent: false });
    this.skillsToStore.emit();
  }

  // mustHaveChanged() {
  //   this.skillsToStore.emit();
  // }

  rangeChanged() {
    const value = this.control.get('experience').value;
    if (!value) {
      this.control.get('years').setValue(0, { emitEvent: false });
      if (this.control.get('isRequired')) {
        this.control.get('isRequired').setValue(false, { emitEvent: false });
      }
    }
    this.skillsToStore.emit();
  }

  optForAssessment(value: boolean) {
    this.control.get('isValidationRequired').setValue(value, { emitEvent: false });
    this.skillsToStore.emit();
  }

  showAssessmentModal = false;
  skillName = '';

  openAssessmentPopup() {
    this.skillName = this.control?.get('name')?.value;
    this.showAssessmentModal = true;
  }

  closeAssessmentPopup(confirmed: boolean) {
    this.showAssessmentModal = false;
    const skillName = this.control?.get('name')?.value;
    this.checkAssessment(skillName);
  }



}
